export default __webpack_public_path__ + "static/media/helpIconHCSelected.53ef9ee9.svg";